import { call, put, takeLatest } from 'redux-saga/effects';
import { apiClient } from '../../utils/axios';
import {
  fetchPdfDataExtractionFailure,
  fetchPdfDataExtractionRequest,
  fetchPdfDataExtractionSuccess,
} from './pdfDataExtractionSlice';

function* fetchPdfDataExtractionSaga(action) {
  try {
    const { query } = action.payload;
    const response = yield call(apiClient.get, '/pdf-data-extractions', { params: query });
    yield put(fetchPdfDataExtractionSuccess(response.data));
  } catch (error) {
    yield put(fetchPdfDataExtractionFailure(error.message));
  }
}

function* businessProfilesSaga() {
  yield takeLatest(fetchPdfDataExtractionRequest.type, fetchPdfDataExtractionSaga);
}

export default businessProfilesSaga;
